import * as actionTypes from "../actions/actionTypes";

// Default data is filled if the is not fetched successfully
const initialState = {
    resumeUrl: "#",
    updatedAt: "Sep 2021",
    errorMsg: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_COMMON_FAILED:
            return {
                ...state,
                errorMsg: action.error,
            };
        case actionTypes.FETCH_COMMON_DATA:
            return {
                ...state,
                resumeUrl: action.commonData.resumeUrl,
                updatedAt: action.commonData.updatedAt,
                errorMsg: null,
            };
        default:
            return state;
    }
};

export default reducer;
